<template>
    <v-container fluid>
        <v-row no-gutters>
            <v-col cols="12">
                <v-data-table
                    class="custom-data-table elevation-1"
					dense
					:headers="instrumentUnitHeaders"
					:loading="$store.getters['instrumentUnit/loading']"
					:items="$store.getters['instrumentUnit/instrumentUnits']"
					:items-per-page="10"
					:search="instrumentUnitSearch"
				>
					<template v-slot:top>
						<v-toolbar dense color="white" :elevation="1" height="34px" class="custom-toolbar mb-2">
							<v-toolbar-title class="subtitle-2">Instrument Unit List</v-toolbar-title>
							<v-divider class="mx-4" inset vertical></v-divider>
                            <v-form class="custom-form"> 
                                <v-text-field v-model="instrumentUnitSearch" dense single-line hide-details outlined placeholder="Search Instrument Unit" autocomplete="off" class="table-search">
                                    <v-icon slot="append">mdi-magnify</v-icon>
                                </v-text-field>
                            </v-form>
                            <v-spacer></v-spacer>
                            <instrument-unit-dialog :icon="true" ref="instumentUnitDialog"></instrument-unit-dialog>
						</v-toolbar>
					</template>
					<template v-slot:[`item.action`]="{ item }">
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="editInstumentUnit(item)" color="primary" v-on="on">mdi-circle-edit-outline</v-icon>
							</template>
							<span>Edit</span>
						</v-tooltip>
						<v-tooltip bottom>
							<template v-slot:activator="{ on }">
								<v-icon small @click="instrumentUnitDeleteId = item.id; $refs.confirmDialog.dialog = true" color="error" v-on="on" >mdi-delete-circle-outline</v-icon>
							</template>
							<span>Delete</span>
						</v-tooltip>
					</template>
				</v-data-table>
                <confirm-dialog ref="confirmDialog" @confirm="deleteInstrumentUnit"></confirm-dialog>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import confirmDialog from "./../../../components/Confirm";
import InstrumentUnitDialog from "./../../../components/InstrumentUnit";

export default {
    name: 'InstrumentUnit',
    components: {
		"confirm-dialog": confirmDialog,
		InstrumentUnitDialog,
    },

    data: ()=> ({
        instrumentUnitHeaders: [
            { text: 'Sl', value: 'sl' },
            { text: 'Name', value: 'name' },
            { text: 'Action ', value: 'action' },
        ],
        instrumentUnitSearch: '',
        instrumentUnitDeleteId: null,
    }),

    created() {
        this.$store.dispatch('instrumentUnit/getInstrumentUnits')
    },

    methods: {

        async editInstumentUnit(instrumentUnit) {
           Object.keys(this.$refs.instumentUnitDialog.instrumentUnit).forEach(key => {
                this.$refs.instumentUnitDialog.instrumentUnit[key] = instrumentUnit[key];
            })

            this.$refs.instumentUnitDialog.showInstrumentUnitDialog = true;
        },

        deleteInstrumentUnit() {
            this.$store.dispatch('instrumentUnit/deleteInstrumentUnit', { id: this.instrumentUnitDeleteId });
            this.$refs.confirmDialog.dialog = false;
        },
    }
}
</script>

<style lang="scss" scoped>
</style>